import { watch, onMounted, ref, provide } from "vue";

export const useLayoutInit = () => {
	const { localeProperties, locale } = useI18n();
	const { fetchStores } = useFetchStores();

	const modalContent = ref<string>("");
	const modalProps = ref<{ position?: string } | null | undefined>({});
	const modalHandler = {
		open: (component: string, props?: object | null) => {
			modalContent.value = component;
			modalProps.value = props;
		},
		close: () => {
			modalContent.value = "";
			modalProps.value = {};
		}
	};

	provide("modal", { modalContent, modalProps, ...modalHandler });

	const initLayoutData = async () => {
		const { initApp } = useInitApp();
		await fetchStores();
		await initApp(localeProperties.value.iso, locale.value);
	};

	watch(locale, async () => {
		await initLayoutData();
	});

	onMounted(() => {
		if (userStore()?.getUser) {
			useWishlistStore().initWishlist();
		}
	});

	return { initLayoutData };
};
